import React from 'react'
import TableComponent, { TableOp } from '../../../components/table/TableOps'
import Http from '../../../Http';

export default class EmbarqueGuiasCartaPorte extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: `embarque/guias-carta`, deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('', [
        { label: 'Guia', id: 'g_folio' },
        { label: 'Estatus', id: 'descripcion' },
      ], []))
    this.table();
  }

  async table() {
    this.setState({ loading: true })
    try {
      let Res = await Http.post(`${this.config.dataUrl}`, { id_embarque: this.props.id_embarque, id_guia: this.props.id_guia, id_cliente: this.props.id_cliente });
      this.setState({ tableData: { ...this.state.tableData, rows: Res.data.rows, total: Res.data.total }, loading: false });
      return Res.data.rows;
    } catch (error) {
      this.setState({ loading: false })
    }
    return [];
  }

  render() {
    return (
      <this.TableRender pagination={false} />
    )
  }
}
